//@getters

import { GetterTree } from "vuex";
import { CenterDesAvocatsState } from "./state";

export const getters: GetterTree<any, CenterDesAvocatsState> = {};
